
import { IncrediTooltip } from 'incredi-ui';
import COLORS from '@/design-system/colors.json';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { IncrediTooltip },
  props: {
    iconSize: {
      type: String,
      default: '12px',
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup() {
    return { COLORS };
  },
  computed: {
    localModelValue: {
      get(): boolean {
        return this.modelValue;
      },
      set(newValue: boolean) {
        this.$emit('update:modelValue', newValue);
      },
    },
  },
});
